// apps/spa/src/components/EmbedEditor/CharCounter.tsx
// Inline "X / max" counter rendered alongside each embed field input.
// CONTEXT Deferred: red/yellow color transitions when approaching limit are
// polish for v2 — neutral muted text only in v1.

import { cn } from '@/lib/utils';

export interface CharCounterProps {
  value: string;
  max: number;
  className?: string;
}

export function CharCounter({ value, max, className }: CharCounterProps) {
  return (
    <span
      className={cn('text-xs text-muted-foreground tabular-nums', className)}
      aria-live="polite"
      data-slot="char-counter"
    >
      {value.length} / {max}
    </span>
  );
}
